import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const saved = localStorage.getItem("auth");
    return saved ? JSON.parse(saved) : { isAuthenticated: false, user: null, token: null };
  });

  useEffect(() => {
    localStorage.setItem("auth", JSON.stringify(auth));
  }, [auth]);

  const login = async (email, password) => {
    // TODO: replace with real API call:
    // const { data } = await axiosInstance.post('/auth/login', { email, password });
    // setAuth({ isAuthenticated: true, user: data.user, token: data.token });

    // Temporary demo auth (hardcoded):
    const DEMO = [
      { email: "admin@driveeasy.co.in", password: "DRVESY#1605", name: "Admin" },
    ];
    const found = DEMO.find(u => u.email === email && u.password === password);
    if (!found) throw new Error("Invalid credentials");
    setAuth({ isAuthenticated: true, user: { name: found.name, email }, token: "demo-token" });
  };

  const logout = () => setAuth({ isAuthenticated: false, user: null, token: null });

  return (
    <AuthContext.Provider value={{ ...auth, login, logout, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
